import VocServicer from "./src/main"

/* istanbul ignore next */
VocServicer.install = function (Vue) {
  Vue.component(VocServicer.name, VocServicer)
}

export default VocServicer
